module.exports = __webpack_public_path__ + "static/02-2-61f487a48d29f6204caf908e40a362e8.jpg";